import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Email Schedules*/
export const registerEmailSchedule = async (emailScheduleData) => {
  try {
    const response = await api.post("/email-schedules", emailScheduleData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "email schedule");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchEmailSchedulesFromAPI = async (page = 1, perPage = 10, search = "", columnFilters = {}, sort = {}) => {
  try {
    const params = {
      page,
      per_page: perPage,
    };

    if (search) {
      params.search = search;
    }

    // Column-specific filters
    if (columnFilters.schedule_name) params.schedule_name = columnFilters.schedule_name;
    if (columnFilters.schedule_type) params.schedule_type = columnFilters.schedule_type;
    if (columnFilters.is_active) params.is_active = columnFilters.is_active;

    if (sort && sort.sortBy) {
      params.sort_by = sort.sortBy;
      params.sort_dir = sort.sortDir === 'desc' ? 'desc' : 'asc';
    }

    const response = await api.get("/email-schedules", { params });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "email schedule");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/* Fetch every schedule matching the filters, walking server pages (for Export). */
export const fetchAllEmailSchedulesForExport = async ({ search = "", columnFilters = {}, sort = {} } = {}, onProgress) => {
  const PER_PAGE = 1000;
  const collected = [];
  let page = 1;
  let total = 0;
  for (;;) {
    const response = await fetchEmailSchedulesFromAPI(page, PER_PAGE, search, columnFilters, sort);
    const payload = response?.data || {};
    const rows = Array.isArray(payload.emailSchedules) ? payload.emailSchedules : [];
    collected.push(...rows);
    total = Number(payload.pagination?.total) || collected.length;
    if (onProgress) onProgress(collected.length, total);
    const lastPage = Number(payload.pagination?.last_page) || 1;
    if (rows.length === 0 || page >= lastPage || collected.length >= total) break;
    page += 1;
  }
  return collected;
};

export const deleteEmailSchedulesFromAPI = async (emailScheduleId) => {
  try {
    const response = await api.delete(`/email-schedules/${emailScheduleId}`, {
      params: { id: emailScheduleId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "email schedule");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchEmailScheduleById = async (emailScheduleId) => {
  try {
    const response = await api.get(`/email-schedules/${emailScheduleId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data email schedule", "email schedule");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateEmailSchedule = async (id, emailScheduleData) => {
  try {
    const response = await api.put(`/email-schedules/${id}`, emailScheduleData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "email schedule");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

/* 📌 Upload Email Schedule Excel File */
export const uploadEmailScheduleFileToAPI = async (formData) => {
  try {
    const response = await api.post("/email-schedules/submit-excel", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("upload email schedule file", "email schedule");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};
